module.exports = __webpack_public_path__ + "static/julia-avatar-d37e00bca1965c57a28d8f975c27eec9.webp";